import React, { CSSProperties } from 'react';
import { DraggableObject, MoveMapImageObject } from '../../reducers/drag/dragReducer';
import MapImageRender from './MapImageRender';

interface DragTokenProps {
    dragInfo: DraggableObject,
    style?: CSSProperties,
    alt?: string,
    className?: string
}

const DragMapImage = ({ dragInfo, style, alt, className  }: DragTokenProps) => {
    const info = (dragInfo as MoveMapImageObject);
    return info?.details.image ? (
        <MapImageRender
            image={info.details.image}
            style={style}
            alt={alt}
            className={className}
            onGrid={false}
        />
    ) : null;
};

export default DragMapImage;
